export enum FeatureToggle {
  CustomRolesV2 = 'rt_custom_roles_v2',
}
